import "./stylesheets/index.pcss";
import "@songfinch/design-system/src/assets/main.scss";
import {createApp} from "vue";
import App from "./app.vue";
export default createApp(App);
